import { addDays } from 'date-fns';

const generateWeeklyCycles = (endYear = new Date().getFullYear()) => {
  // Start weekly payment cycles from May 5, 2025
  const startDate = new Date(2025, 4, 5); // Month is 0-indexed, so 4 is May
  const startYear = startDate.getFullYear();
  const resolvedEndYear = Math.max(endYear, startYear);
  const endDateBoundary = new Date(resolvedEndYear, 11, 31); // Dec 31 of end year

  const cycles = [];
  let startDateOfWeek = startDate;
  let weekNumber = 1;

  while (startDateOfWeek <= endDateBoundary) {
    const cycleEndDate = addDays(startDateOfWeek, 6);

    cycles.push({
      value: startDateOfWeek,
      label: `Week ${weekNumber}:
      ${startDateOfWeek.getFullYear()}-${String(startDateOfWeek.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(startDateOfWeek.getDate()).padStart(2, '0')} -
      ${cycleEndDate.getFullYear()}-${String(cycleEndDate.getMonth() + 1).padStart(
        2,
        '0',
      )}-${String(cycleEndDate.getDate()).padStart(2, '0')}`,
      endDate: cycleEndDate,
    });

    startDateOfWeek = addDays(startDateOfWeek, 7);
    weekNumber++;
  }

  return cycles;
};

const weeklyCycles = generateWeeklyCycles();

const getCurrentCycle = () => {
  const today = new Date();
  const currentCycle = weeklyCycles.find(cycle => today >= cycle.value && today <= cycle.endDate);
  return currentCycle || weeklyCycles[0];
};

const formatDateAsString = date => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

const getCycleByStartDate = startDate => {
  const searchDateStr = typeof startDate === 'string' ? startDate : formatDateAsString(startDate);
  return weeklyCycles.find(cycle => {
    const cycleDateStr = formatDateAsString(cycle.value);
    return cycleDateStr === searchDateStr;
  });
};

const currentCycle = getCurrentCycle();

export { weeklyCycles, currentCycle, formatDateAsString, getCycleByStartDate };
